import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classnames from 'classnames';
import { parseAmount, friendlyCreditCardMask } from 'app/utils/parsers';
import { renderAssemblyJs } from 'app/utils/assembly';
import HeaderThin from 'app/components/layout/HeaderThin';
import { Link } from 'react-router-dom';
// import history from 'app/routes/history';
import { changeState } from '@teammo/teammo-general-utils';
import Isvg from 'react-inlinesvg';

import Button from 'app/components/general/Button';
import InputGroupBlock from 'app/components/general/InputGroupBlock';
import { Label, Collapse, Tooltip } from 'reactstrap';
import Loader from 'app/components/general/Loader';
import SectionGroup from 'app/components/general/SectionGroup';
import ModalConfirm from 'app/components/general/ModalConfirm';
import PaymentCardMin from 'app/components/matches/PaymentCardMin';

import CreditCardInput from 'app/components/general/CreditCardInput';
import CreditCardInputNew from 'app/components/general/CreditCardInputNew';
import Checkbox from 'app/components/general/Checkbox';
import HelpTooltip from 'app/components/general/HelpTooltip';
import PaymentProcessingLoader from 'app/components/teamPaymentRequests/PaymentProcessingLoader';

import MastercardIcon from 'app/images/icons/credit-card-mastercard.svg';
import VisaIcon from 'app/images/icons/credit-card-visa.svg';
import LockIcon from 'app/images/icons/lock.svg';
import IconButton from 'app/components/general/IconButton';
import PlusIcon from 'app/images/icons/plus.svg';
import RemoveIcon from 'app/images/icons/remove.svg';

import * as creditCardActions from 'app/ducks/creditCards/actions';

import * as loadingSelectors from 'app/ducks/loading/selectors';
import * as creditCardSelectors from 'app/ducks/creditCards/selectors';
import * as userSelectors from 'app/ducks/users/selectors';
import CartSummary from '../CartSummary';

interface IPaymentMethodsProps {
  actions: any;
  appReady: any;
  creditCards: any;
  users: any;
  errors: any;
  processingBackendErrors: any;
}

export interface IPaymentMethodsState {
  cardName: string;
  cardNumber: string;
  cardExpiry: string;
  cardCvv: string;
  errors: {
    cardName?: string;
    cardNumber?: string;
    cardExpiry?: string;
    cardCvv?: string;
  };
  saveCardAllowed: boolean;
  accepted: boolean;
  backendErrors: any;
  processingBackendErrors: any;
  isLoading: boolean;
  cardSecurityTooltip: boolean;
  changed: boolean;
  newCard: boolean;
  deleteModalOpen: boolean;
  existingCard: boolean;
  existingCardMaskedNumber: string;
  existingCardExpiry: string;
  creditCardFormReady: boolean;
  providerProcessing: boolean;
  createCardError: boolean;
}

function selector(state): any {
  return {
    appReady: loadingSelectors.appReady(state),
    creditCards: creditCardSelectors.getCreditCards(state),
    users: userSelectors.getUsers(state),
    errors: {
      ...state.purchases.backendErrors,
      ...state.creditCards.backendErrors,
    },
    processingBackendErrors: state.creditCards.processingBackendErrors,
  };
}

const actionCreators = _.merge(
  creditCardActions,
);

@(connect(selector, (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
})) as any)
export default class PaymentMethods extends React.Component<
IPaymentMethodsProps,
IPaymentMethodsState
> {
  static defaultProps: IPaymentMethodsProps = {
    appReady: undefined,
    creditCards: undefined,
    users: undefined,
    errors: undefined,
    processingBackendErrors: undefined,
  };

  state = {
    cardName: '',
    cardNumber: '',
    cardCvv: '',
    cardExpiry: '',
    errors: {
      cardName: undefined,
      cardNumber: undefined,
      cardExpiry: undefined,
      cardCvv: undefined,
    },
    backendErrors: {},
    processingBackendErrors: {},
    saveCardAllowed: false,
    accepted: true,
    cardSecurityTooltip: false,
    changed: false,
    newCard: false,
    deleteModalOpen: false,
    existingCard: false,
    existingCardMaskedNumber: '',
    existingCardExpiry: '',
    creditCardFormReady: false,
    providerProcessing: false,
    createCardError: false,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    const existingCard = !_.isEmpty(nextProps.creditCards.currentCreditCard.id) && nextProps.creditCards.currentCreditCard?.status !== 'inactive';
    let newState = { ...prevState };
    if (
      !prevState.changed
      && nextProps.backendErrors !== prevState.backendErrors
    ) {
      newState = {
        ...newState,
        backendErrors: nextProps.backendErrors,
      };
    }
    if (!prevState.changed && (prevState.newCard !== existingCard || nextProps.creditCards.currentCreditCard.id !== prevState.existingCardId)) {
      newState = {
        ...newState,
        newCard: !existingCard,
        existingCard,
        existingCardId: nextProps.creditCards.currentCreditCard.id,
        existingCardMaskedNumber: nextProps.creditCards.currentCreditCard.creditCardMask,
        existingCardExpiry: nextProps.creditCards.currentCreditCard.creditCardExpiry,
      };
    }
    return newState;
  }

  componentDidMount = () => {
    this.props.actions.getAllCreditCards();
  };

  validateCard = () => !(
    this.state.errors.cardName
    || this.state.errors.cardNumber
    || this.state.errors.cardExpiry
    || this.state.errors.cardCvv
  );

  handleChange = (fieldName, valid) => {
    this.setState((previousState) => {
      const newState = {
        backendErrors: undefined,
        changed: true,
        createCardError: false,
        [fieldName]: valid,
      };
      return newState;
    });
  };

  handleCardSecurityTooltipToggle = () => {
    this.setState((previousState) => ({
      cardSecurityTooltip: !previousState.cardSecurityTooltip,
    }));
  };

  handleAllowSaveCard = () => {
    this.setState((previousState) => ({
      saveCardAllowed: !previousState.saveCardAllowed,
    }));
  };

  handleAcceptTerms = () => {
    this.setState((previousState) => ({
      accepted: !previousState.accepted,
    }));
  };

  handleNewCardSubmit = (e, asmPayload) => {
    e.preventDefault();
    if (this.state.newCard) {
      const cardAccountId = asmPayload?.card_accounts?.id;

      this.setState({
        providerProcessing: true,
      });

      if (!_.isEmpty(asmPayload)) {
        if (this.validateCard()
          && this.props.creditCards.creditCardToken
          && !_.isEmpty(cardAccountId)) {
          this.setState({
            changed: false,
            backendErrors: {},
          }, () => {
            const cardPayload = {
              cardAccountId,
              user: { id: this.props.users.currentUser.id },
              status: 'active',
              consumer: { id: null },
            };
            this.props.actions.createCreditCard(cardPayload, () => this.setState({
              providerProcessing: false,
            }));
          });
        }
      }
    }
  };

  handleNewCardSubmitError = (e, asmPayload) => {
    e.preventDefault();
    if (this.state.newCard) {
      if (!_.isEmpty(asmPayload?.errors)) {
        this.setState({
          providerProcessing: false,
          createCardError: true,
        });
        this.props.actions.createCreditCardToken({
          secureReference: this.props.secureReference,
          user: { id: this.props.users.currentUser.id },
        });
      }
    }
  }

  handleCardAddingStatus = () => {
    this.setState({
      providerProcessing: true,
    });
  }

  handleSelectNewCard = () => {
    this.props.actions.createCreditCardToken({
      secureReference: this.props.secureReference,
      user: { id: this.props.users.currentUser.id },
    });
    this.setState((previousState) => ({
      newCard: true,
      backendErrors: {},
      creditCardFormReady: false,
      existingCard: false,
      changed: true,
    }));
  };

  handleCancelNewCard = () => {
    const existingCard = !_.isEmpty(this.props.creditCards.currentCreditCard.id) && this.props.creditCards.currentCreditCard?.status !== 'inactive';

    this.setState((previousState) => ({
      newCard: false,
      existingCard,
      backendErrors: {},
    }));
  };

  handleDeleteSubmit = () => {
    this.props.actions.deleteCreditCard({ id: this.props.creditCards.currentCreditCard.id, status: 'inactive' });
    this.setState({ deleteModalOpen: false });
  }

  handleOpenDeleteModal = (e): void => {
    e.preventDefault();

    this.setState({ deleteModalOpen: true });
  };

  handeCloseDeleteModal = (e): void => {
    e.preventDefault();
    this.setState({ deleteModalOpen: false });
  };

  handleSelectExistingCard = () => {
    this.setState((previousState) => ({
      existingCard: true,
      backendErrors: {},
      newCard: false,
      creditCardFormReady: false,
      changed: true,
    }));
  };

  handleFormIsReady = (isReady) => {
    this.setState({ creditCardFormReady: isReady });
  };

  isValid = () => {
    if (this.state.newCard) {
      return (
        this.state.cardName
        && this.state.cardNumber
        && this.state.cardExpiry
        && this.state.cardCvv
        && this.state.accepted
      );
    }
    if (this.state.existingCard) {
      return this.state.accepted;
    }
    return false;
  };

  renderBackendErrors = (): React.ReactNode => {
    if (
      this.state.backendErrors !== undefined
      && this.state.backendErrors.message !== undefined
    ) {
      return (
        <span className="text-left backend-errors">
          {this.state.backendErrors.message}
        </span>
      );
    }
    return null;
  };

  renderPaymentMethodSelection = (): React.ReactNode => {
    const existingCard = `Ending with ${friendlyCreditCardMask(this.props.creditCards.currentCreditCard.creditCardMask)} expires (${this.props.creditCards.currentCreditCard.creditCardExpiry})`;
    const hasExistingCard = !_.isEmpty(this.props.creditCards.currentCreditCard.id) && this.props.creditCards.currentCreditCard?.status !== 'inactive';
    return (
      <div>
        <form id="new-asm-card" onSubmit={this.handleNewCardSubmit}>
          <div className={classnames('row', { 'd-none': !this.props.cardIsLoading })}>
            <div className="col">
              <Loader isActive className="relative" color="grey" />
            </div>
          </div>
          <Collapse isOpen={!this.state.newCard}>
            <div className={classnames({ 'd-none': this.props.cardIsLoading })}>
              {hasExistingCard && (
                <div className="row">
                  <div className="col col-lg-6">
                    <InputGroupBlock
                      type="text"
                      icon={LockIcon}
                      labelText="Saved card on file"
                      placeholder="Saved card on file"
                      aria-label="Saved card on file"
                      autoComplete="off"
                      disabled
                      tabIndex="1"
                      name="cardMask"
                      value={existingCard}
                    />
                  </div>
                </div>
              )}
              <div className="row">
                <div className="col">
                  <div className="btn-flex-group">
                    <div className="btn-flex-container">
                      <Button
                        className="btn-2"
                        type="button"
                        noLoading
                        onClick={this.handleSelectNewCard}
                      >
                        {hasExistingCard ? 'Update' : 'Add'}
                        {' '}
                        card
                      </Button>
                      {hasExistingCard && (
                        <Button
                          className="btn-2"
                          type="button"
                          noLoading
                          onClick={this.handleOpenDeleteModal}
                        >
                          Remove card
                        </Button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Collapse>
          <Collapse isOpen={this.state.newCard}>
            {this.state.newCard && this.renderNewCard()}
          </Collapse>
        </form>
      </div>
    );
  }

  renderNewCard = (): React.ReactNode => (
    <div>
      <div className="row">
        <div className="col">
          <div className="form-description">
            Only Visa & Mastercard are accepted.
          </div>
        </div>
      </div>
      <div className="row with-margin-top-10">
        <div className="col">
          <div className="border border-round with-padding">
            <div className={classnames('row', { 'd-none': this.state.creditCardFormReady })}>
              <div className="col">
                <Loader skeleton count={3} isActive color="grey" />
              </div>
            </div>
            <div className={classnames('row', { 'd-none': !this.state.creditCardFormReady })}>
              <div className="col col-12">
                <CreditCardInputNew
                  isLoading={this.props.creditCards.isLoading}
                  newCard={this.state.newCard}
                  handleChange={this.handleChange}
                  handleSubmit={this.handleNewCardSubmit}
                  handleSubmitError={this.handleNewCardSubmitError}
                  handleFormIsReady={this.handleFormIsReady}
                  handleCardAddingStatus={this.handleCardAddingStatus}
                  // handleIsSubmitting={this.handleIsSubmitting}
                  // handleIsNotSubmitting={this.handleIsNotSubmitting}
                  creditCardToken={this.props.creditCards.creditCardToken}
                  creditCardUserId={this.props.users.currentUser.id}
                />
              </div>
            </div>
            {this.props.creditCards.creditCardToken !== undefined && (
              <div className="row with-margin-top">
                <div className="col text-right">
                  <Button
                    className="btn-2 margin-right-10"
                    type="button"
                    noLoading
                    onClick={this.handleCancelNewCard}
                  >
                    Cancel
                  </Button>
                  <Button
                    className="btn-success"
                    type="submit"
                    disabled={this.props.creditCards.isSaving || !this.isValid() || this.state.providerProcessing}
                    isLoading={this.props.creditCards.isSaving || this.state.providerProcessing}
                    hasFailed={this.props.creditCards.hasFailed || this.state.createCardError}
                    hasSaved={this.props.creditCards.hasSaved && !this.state.providerProcessing && !this.state.createCardError}
                  >
                    Save card
                  </Button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );

  render(): React.ReactNode {
    // renderAssemblyJs();
    // console.log(this.props.isLoading)
    return (
      <div>
        <div className="row">
          <div className="col">
            <HeaderThin title="Payment Methods" divider />
          </div>
        </div>
        <ModalConfirm
          title="Delete credit / debit card"
          description="Are you sure you want to delete this credit / debit card?"
          buttonText="Delete"
          buttonClassName="btn-1 primary"
          isOpen={this.state.deleteModalOpen}
          isLoading={this.props.creditCards.isLoading}
          handleSubmit={this.handleDeleteSubmit}
          handleCancel={this.handeCloseDeleteModal}
        />
        <div className="row">
          <div className="col">
            <SectionGroup
              title="Credit / debit card"
              isLoading={this.props.isLoading}
            >
              <div className="row">
                <div className="col col-12 form-description text-black">
                  {this.renderBackendErrors()}
                </div>
              </div>
              {this.renderPaymentMethodSelection()}
            </SectionGroup>
          </div>
        </div>
      </div>
    );
  }
}
